import React from 'react';
import { commitments } from '../../data/firm';
import { SectionHeading } from '../ui/SectionHeading';
export function HomeWhy() {
  return <section className="bg-limestone py-24 lg:py-32" data-id="element-279" data-mp="1kqtgospe0m7f">
      <div className="mx-auto max-w-7xl px-6 lg:px-10" data-id="element-280" data-mp="15srf2o1x2ast">
        <SectionHeading label="Why Aurevane" title="Commitments we make to every client and candidate" intro="The principles that guide how we conduct every search — commitments to the way we work, not claims about the past." data-id="element-281" data-mp="15uc98ckbjrq5" />
        <ul className="mt-16 grid gap-x-12 gap-y-12 md:grid-cols-2 lg:grid-cols-3" data-id="element-282" data-mp="23eopdy6579to">
          {commitments.map(c => <li key={c.title} className="border-t border-plum/15 pt-6" data-id="element-283" data-mp="1oqtxgjzyl9hn">
              <h3 className="font-serif text-2xl font-medium text-aubergine" data-id="element-284" data-mp="1tovobr3mmd3o">{c.title}</h3>
              <p className="mt-3 leading-relaxed text-plum/70" data-id="element-285" data-mp="2hepz834dxrla">{c.description}</p>
            </li>)}
        </ul>
      </div>
    </section>;
}